module.exports = __webpack_public_path__ + "media/components/assets/img/flag/pl-d9a4e5147fdbba920ec7883009eee611.svg";